import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

class WebComponent extends HTMLElement {
  connectedCallback() {
    if (process.env.NODE_ENV === 'test') {
      // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
      const { worker } = require('./mocks/browser');
      worker.start({ onUnhandledRequest: 'bypass' });
    }
    ReactDOM.render(<App />, this);
  }
}

const ELEMENT_ID = 'voebiz-react-miles-batch-beneficiaries';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
